import React from 'react'
import { Link } from 'react-router-dom'

// Shared plan features data
export const PLAN_FEATURES = {
  free: [
    '1 vehicle',
    'Unlimited maintenance entries',
    'Service reminders',
    'Basic shareable log link',
    'VIN decoder',
    'Cost tracking & analytics'
  ],
  premiumOnly: [
    'Up to 99 vehicles',
    'Photos & receipts on every log',
    'PDF export',
    'Full share page: photos, costs, service compliance',
    'Priority support'
  ]
}

function Check() {
  return (
    <svg className="w-4 h-4 mt-1 flex-shrink-0 text-ink" fill="none" stroke="currentColor" strokeWidth={3} viewBox="0 0 24 24" aria-hidden="true">
      <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
    </svg>
  )
}

function FeatureList({ items }) {
  return (
    <ul className="space-y-2.5 mb-8">
      {items.map((feature) => (
        <li key={feature} className="flex items-start gap-2.5 text-ink">
          <Check />
          <span>{feature}</span>
        </li>
      ))}
    </ul>
  )
}

export function FreePlanCard({ variant = 'landing', linkTo = '/get-started' }) {
  const isSelection = variant === 'selection'

  return (
    <div className="bg-surface border-[1.5px] border-ink p-6 sm:p-8 flex flex-col">
      <p className="text-[11px] font-bold uppercase tracking-widest text-muted mb-2">Free</p>
      <p className="mb-5">
        <span className="font-mono text-4xl font-medium text-ink">$0</span>
        <span className="text-muted ml-2">forever</span>
      </p>
      {isSelection && (
        <p className="text-muted mb-5">
          Everything you need to keep a complete log for one vehicle.
        </p>
      )}
      <FeatureList items={PLAN_FEATURES.free} />
      <Link
        to={linkTo}
        className="mt-auto block w-full text-center px-6 py-3 font-bold text-ink border-[1.5px] border-ink hover:bg-white"
      >
        {isSelection ? 'Continue with Free' : 'Start free'}
      </Link>
    </div>
  )
}

export function PremiumPlanCard({ variant = 'landing', linkTo = '/get-started' }) {
  const isSelection = variant === 'selection'

  return (
    <div className="bg-surface border-[1.5px] border-ink p-6 sm:p-8 flex flex-col">
      <p className="text-[11px] font-bold uppercase tracking-widest text-accent mb-2">Premium</p>
      <p className="mb-1">
        <span className="font-mono text-4xl font-medium text-ink">$3.99</span>
        <span className="text-muted ml-2">per month</span>
      </p>
      <p className="mb-5 text-sm text-muted">or $36.99 per year</p>
      {isSelection && (
        <p className="text-muted mb-5">
          For more than one vehicle, or when you want receipts and a full report to hand over.
        </p>
      )}
      <p className="text-sm font-bold text-ink mb-3">Everything in Free, plus:</p>
      <FeatureList items={PLAN_FEATURES.premiumOnly} />
      <Link
        to={linkTo}
        className="mt-auto block w-full text-center px-6 py-3 font-bold text-white bg-accent hover:bg-accent-dark"
      >
        {isSelection ? 'Continue with Premium' : 'Start with Premium'}
      </Link>
      {isSelection && (
        <p className="text-xs text-center text-muted mt-3">
          You can upgrade anytime from your account
        </p>
      )}
    </div>
  )
}
